// TelcoTrack - Spinner Component
// Reusable loading spinner with design-system animation and size variants

import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' = 'md';
  @Input() ariaLabel = 'Načítání…';
}
